import React, { useState, useEffect, useRef } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	IconButton,
	CircularProgress,
	Box,
	Alert,
	Skeleton,
	Tooltip,
} from "@mui/material";
import { ApiService } from "../../ApiService";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { returnFullURL } from "../../../utils/goblaFunctions";

import { QRCodeSVG } from 'qrcode.react';
import { Canvg } from 'canvg';

import fondo_intro_jhimbo from "../../../images/fondo_intro_jhimbo.png";

import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import ReplyIcon from "@mui/icons-material/Reply";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import InfoIcon from '@mui/icons-material/Info';
import DownloadIcon from '@mui/icons-material/Download';
import LogoHosmingSVG from "../../../svg/LogoHosmingSVG";
import { ModalForAll } from "../../global/ModalForAll";

const HomePerfilEdit = ({ liked, handleLike, isFollowed, handleClickFollow, keyBranch, data, loading }) => {
	const [openPerfil, setOpenPerfil] = useState(false);
	const [openBanner, setOpenBanner] = useState(false);
	const [imgPerfil, setImgPerfil] = useState(null);
	const [imgBanner, setImgBanner] = useState(null);
	const [previewImg, setPreviewImg] = useState(null);
	const [currentTipo, setCurrentTipo] = useState("");
	const [uploadLoading, setUploadLoading] = useState(false);
	const [error, setError] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const ApiUrl = process.env.REACT_APP_API_URL;
	const [profileImageLoaded, setProfileImageLoaded] = useState(false);
	const [bannerImageLoaded, setBannerImageLoaded] = useState(false);

	const { nit } = useParams();

	const contenedorRef = useRef(null);
	const [modalShare, setModalShare] = useState();
	const companyName = data?.name ?? "nombre de la empresa";;
	const link_share = String(window.location.protocol) + '//' + String(window.location.hostname) + '/company/products?search=' + nit;

	function copyLinkShare() {
		return new Promise((resolve, reject) => {
			if (!navigator.clipboard) {
				reject(new Error('La API del portapapeles no está disponible'));
				return;
			}
			// Intentar copiar el texto
			navigator.clipboard.writeText(link_share ?? "No se pudo copiar...")
				.then(() => {
					resolve();
					toast.success("Copiado exitosamente", {
						position: 'top-center',
						closeButton: false,
						autoClose: 1500,
						hideProgressBar: false
					});
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	useEffect(() => {
		if (data) {
			setProfileImageLoaded(false);
			setBannerImageLoaded(false);
			if (data.profile) {
				setImgPerfil(data.profile);
			} else {
				setImgPerfil(null);
				setProfileImageLoaded(true);
			}
			if (data.cover_url) {
				setImgBanner(data.cover_url);
			} else {
				setImgBanner(null);
				setBannerImageLoaded(true);
			}
		}
	}, [data]);
	useEffect(() => {
		if (!imgPerfil) setProfileImageLoaded(true);
		if (!imgBanner) setBannerImageLoaded(true);
	}, [imgPerfil, imgBanner]);

	const handleOpenModal = (tipo) => {
		setError(null);
		setPreviewImg(null);
		setSelectedFile(null);
		setCurrentTipo(tipo);
		if (tipo === "perfil") setOpenPerfil(true);
		else setOpenBanner(true);
	};

	const handleCloseModal = () => {
		setOpenPerfil(false);
		setOpenBanner(false);
		setPreviewImg(null);
		setSelectedFile(null);
		setError(null);
	};

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setSelectedFile(file);
			const reader = new FileReader();
			reader.onload = (evt) => {
				setPreviewImg(evt.target.result);
			};
			reader.readAsDataURL(file);
		}
	};

	const handleAccept = async () => {
		if (!selectedFile) return;
		setUploadLoading(true);
		setError(null);

		try {
			const formData = new FormData();
			formData.append("file", selectedFile);
			const uploadResponse = await ApiService.fetchData(
				"api/upload/file",
				{ method: "POST", body: formData },
				false
			);
			if (uploadResponse?.url) {
				const field = currentTipo === "perfil" ? "profile_url" : "company_cover";
				const body = {
					[field]: uploadResponse.url,
				};
				const url = `api/company/update/main?key_branch=${keyBranch}`;
				const updateResponse = await ApiService.fetchData(url, {
					method: "PUT",
					body: JSON.stringify(body),
				});
				if (updateResponse?.code === 200) {
					toast.success(updateResponse.message);
					if (currentTipo === "perfil") {
						setImgPerfil(updateResponse.profile);
					} else {
						setImgBanner(updateResponse.cover_url);
					}
					handleCloseModal();
				} else {
					setError("Error al actualizar los datos de la empresa");
				}
			} else {
				setError("Error al subir la imagen");
			}
		} catch (err) {
			setError("Ocurrió un error al procesar la imagen");
		} finally {
			setUploadLoading(false);
		}
	};
	const handleRemovePreview = () => {
		setPreviewImg(null);
		setSelectedFile(null);
	};
	if (loading || !data) {
		return (
			<div style={{ paddingTop: "75px" }}>
				{/* Banner skeleton */}
				<Skeleton
					variant="rectangular"
					width="100%"
					height={200}
					animation="wave"
					sx={{ bgcolor: "rgba(0, 0, 0, 0.08)" }}
				/>

				<div className="info-company" style={{ display: "flex", padding: "20px" }}>
					{/* Profile image skeleton */}
					<Skeleton
						variant="circular"
						width={120}
						height={120}
						animation="wave"
						sx={{ mr: 2, bgcolor: "rgba(0, 0, 0, 0.08)" }}
					/>

					<div style={{ display: "flex", flexDirection: "column", width: "86%" }}>
						{/* Company name skeleton */}
						<Skeleton
							variant="text"
							width="60%"
							height={40}
							animation="wave"
							sx={{ mb: 2, bgcolor: "rgba(0, 0, 0, 0.08)" }}
						/>

						{/* Stats section skeleton */}
						<Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
							{[1, 2, 3, 4].map((item) => (
								<Box
									key={item}
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										width: "23%",
									}}>
									<Skeleton
										variant="text"
										width={40}
										height={24}
										animation="wave"
										sx={{ bgcolor: "rgba(0, 0, 0, 0.08)" }}
									/>
									<Skeleton
										variant="text"
										width={70}
										height={16}
										animation="wave"
										sx={{ bgcolor: "rgba(0, 0, 0, 0.08)" }}
									/>
								</Box>
							))}
						</Box>
					</div>
				</div>
			</div>
		);
	}

	const info_company = (
		<>
			<div className="actions-company">
				<span className="text-size text-bold">0</span>
				<span className="text-size">Estrellas</span>
			</div>

			<div className="actions-company">
				<span className="text-size text-bold">0</span>
				<span className="text-size">Seguidores</span>
			</div>

			<div className="actions-company">
				<span className="text-size text-bold">0</span>
				<span className="text-size" style={{ whiteSpace: 'nowrap' }}>Me gusta</span>
			</div>

			<div className="actions-company">
				<span className="text-size text-bold">0</span>
				<span className="text-size">Visitas</span>
			</div>

			<div className="actions-company">
				<span className="text-size text-bold">0</span>
				<span className="text-size">Compartidos</span>
			</div>
		</>
	);

	const handleDownloadSVG = async () => {
		if (!contenedorRef.current) return;

		// Obtener los SVGs dentro del contenedor
		const svg = contenedorRef.current.querySelectorAll('svg');
		if (!svg) return;

		// Clonar los SVGs
		const svgClone = svg[0].cloneNode(true);
		const svgClone2 = svg[1].cloneNode(true);
		const svgClone3 = svg[2]?.cloneNode(true) ?? null;

		// Ajustar tamaño principal
		svgClone.style.margin = '30px';
		svgClone.style.width = '900px';
		svgClone.style.height = '900px';

		// Crear <defs> con gradiente
		const xmlns = "http://www.w3.org/2000/svg";
		const defs = document.createElementNS(xmlns, "defs");
		const linearGradient = document.createElementNS(xmlns, "linearGradient");
		linearGradient.setAttribute("id", "gradienteRojoAzul");
		linearGradient.setAttribute("x1", "0%");
		linearGradient.setAttribute("y1", "0%");
		linearGradient.setAttribute("x2", "100%");
		linearGradient.setAttribute("y2", "100%");

		const stop1 = document.createElementNS(xmlns, "stop");
		stop1.setAttribute("offset", "0%");
		stop1.setAttribute("stop-color", "red");

		const stop2 = document.createElementNS(xmlns, "stop");
		stop2.setAttribute("offset", "100%");
		stop2.setAttribute("stop-color", "black");

		linearGradient.appendChild(stop1);
		linearGradient.appendChild(stop2);
		defs.appendChild(linearGradient);

		// Insertar defs al principio del SVG principal
		svgClone.insertBefore(defs, svgClone.firstChild);

		// Escalar y posicionar los SVGs secundarios
		if (svgClone3) {
			svgClone3.style = 'none';
			svgClone3.setAttribute("width", "40%");
			svgClone3.setAttribute("height", "40%");
			svgClone3.setAttribute("x", "10");
			svgClone3.setAttribute("y", "11");
			svgClone2.setAttribute("transform", "scale(1)");
			svgClone.appendChild(svgClone3); // Primero svgClone3 (atrás)
		}

		svgClone2.style = 'none';
		svgClone2.setAttribute("width", "40%");
		svgClone2.setAttribute("height", "40%");
		svgClone2.setAttribute("x", "10");
		svgClone2.setAttribute("y", "11");
		svgClone.appendChild(svgClone2); // Luego svgClone2 (encima)

		// Exportar
		const svgData = new XMLSerializer().serializeToString(svgClone);

		const canvas = document.createElement('canvas');
		canvas.width = 1500;
		canvas.height = 1500;
		const ctx = canvas.getContext('2d');

		const v = await Canvg.from(ctx, svgData);
		await v.render();

		const pngUrl = canvas.toDataURL('image/png');
		const downloadLink = document.createElement('a');
		downloadLink.href = pngUrl;
		downloadLink.download = 'qrcode.png';
		downloadLink.click();
	};

	return (
		<div>
			<div className="cover-company" style={{ position: 'relative' }}>
				<img
					src={returnFullURL(imgBanner, 'cover')}
				/>
				<Tooltip title="Editar Banner">
					<IconButton
						size="small"
						onClick={() => handleOpenModal("banner")}
						sx={{
							"position": "absolute",
							"top": 10,
							"right": 10,
							"backgroundColor": "#e62e2d",
							"zIndex": 2,
							"&:hover": { backgroundColor: "#e62e2d" },
						}}>
						<EditIcon fontSize="small" sx={{ color: "#fff" }} />
					</IconButton>
				</Tooltip>
			</div>

			<div
				style={{
					backgroundImage: `url(${fondo_intro_jhimbo})`,
					backgroundSize: "cover",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "center",
				}}
			>
				<div className="head-data-company">
					<div className="profile-company">
						<div className="logo-company" style={{ position: 'relative',boxShadow: '0px 0px 5px 1px var(--theme-company)' }}>
							<img src={returnFullURL(imgPerfil)} alt={"logo empresa " + companyName} />
							<button
								className="default-buttons button-company"
								onClick={() => handleOpenModal("perfil")}
							>
								<span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '30px', fontWeight: '550' }}>
									<EditIcon sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '30px' }} />
									Editar
								</span>
							</button>
						</div>

						<button className="follow-button-company" onClick={handleClickFollow}>
							{isFollowed ? <CheckIcon /> : <AddIcon />}
						</button>
					</div>

					<div className="head-info">
						<div>
							<h2 className="font-h2">{companyName}</h2>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', border: '1px solid rgba(0,0,0,0.3)', borderRadius: '10px', padding: '10px' }}>
							<div className="section-actions">
								<div className="actions-company" onClick={handleLike} style={{ cursor: "pointer" }}>
									{liked ? (
										<StarIcon
											style={{
												color: "#FFC107",
												fontSize: "20px",
											}}
										/>
									) : (
										<StarBorderIcon
											style={{
												color: "#FFC107",
												fontSize: "20px",
											}}
										/>
									)}
									<span style={{ fontSize: 'var(--font-size-p)' }}>Favorito</span>
								</div>

								<button className="default-buttons actions-company" disabled={data ? false : true} onClick={() => setModalShare(true)}>
									<ReplyIcon
										style={{
											color: 'var(--theme-company)',
											fontSize: "20px",
										}}
									/>
									<span style={{ fontSize: 'var(--font-size-p)' }}>Compartir</span>
								</button>

								<div className="actions-company" style={{ position: 'relative' }} id="more-info">
									<InfoIcon
										style={{
											color: 'var(--theme-company)',
											fontSize: "20px",
										}}
									/>
									<span className="text-size">Mas</span>

									<div className="modal-info-company shadow-company">
										{
											info_company
										}
									</div>
								</div>
							</div>

							<div id='info-company-pc'>
								{
									info_company
								}
							</div>
						</div>
					</div>
				</div>
			</div>

			<Dialog open={openPerfil || openBanner} onClose={handleCloseModal} maxWidth="sm" fullWidth>
				<DialogTitle>Cambiar {currentTipo === "perfil" ? "Foto de Perfil" : "Banner"}</DialogTitle>
				<DialogContent>
					{error && (
						<Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
							{error}
						</Alert>
					)}

					{!previewImg && (
						<Button variant="contained" component="label" disabled={uploadLoading}>
							Subir Imagen
							<input type="file" hidden accept="image/*" onChange={handleImageChange} />
						</Button>
					)}

					{previewImg && (
						<Box position="relative" mt={2} display="flex" justifyContent="center">
							<img
								src={previewImg}
								alt="preview"
								style={{
									width: "300px",
									height: "auto",
									borderRadius: currentTipo === "perfil" ? "50%" : "8px",
									objectFit: "contain",
									boxShadow: "0 0 10px rgba(0,0,0,0.2)",
								}}
							/>
							<IconButton
								onClick={handleRemovePreview}
								disabled={uploadLoading}
								sx={{
									"position": "absolute",
									"top": "-10px",
									"right": "100px",
									"backgroundColor": "red",
									"&:hover": { backgroundColor: "darkred" },
								}}>
								<CloseIcon sx={{ color: "#fff" }} />
							</IconButton>
						</Box>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseModal} disabled={uploadLoading}>
						Cancelar
					</Button>
					<Button
						onClick={handleAccept}
						disabled={!previewImg || uploadLoading}
						variant="contained"
						startIcon={uploadLoading ? <CircularProgress size={20} /> : null}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault();
								handleAccept();
							}
						}}>
						{uploadLoading ? "Subiendo..." : "Aceptar"}
					</Button>
				</DialogActions>
			</Dialog>

			<ModalForAll stateModal={modalShare} setStateModal={setModalShare}>
				<div className="container-share">
					<div>
						<h3>Compartir Empresa</h3>
						<p>Invita a otros a conocer "{companyName}" compartiendo este enlace único. El código QR también puede ser escaneado desde dispositivos móviles.</p>
					</div>

					<div className="container-qr" >
						<div style={{ position: 'relative' }} ref={contenedorRef}>
							<QRCodeSVG
								value={link_share}
								size={300}
								includeMargin={false}
								fgColor={'url(#gradienteRojoAzul)'}
							/>

							<LogoHosmingSVG color='rgb(255,0,0)' stroke={false} style_code={{
								width: '120px',
								height: '120px',
								position: 'absolute',
								top: '50%',
								left: '50%',
								zIndex: '5',
								transform: 'translate(-50%,-50%)',
							}}
							/>

							<LogoHosmingSVG color='#fff' stroke={true} style_code={{
								width: '120px',
								height: '120px',
								position: 'absolute',
								top: '50%',
								left: '50%',
								zIndex: '2',
								transform: 'translate(-50%,-50%)',
							}}
							/>
						</div >

						<button className="default-buttons" onClick={() => handleDownloadSVG()} style={{ backgroundColor: 'transparent' }}><DownloadIcon sx={{ fontSize: '40px', color: '#000' }} /></button>
					</div>

					<div style={{ width: '100%', display: 'flex', gap: '10px' }}>
						<input className="shadow-lvl6" type="text" value={link_share} style={{ width: '100%' }} readOnly />
						<button className="default-buttons" onClick={() => copyLinkShare()}>Copiar!</button>
					</div>
				</div>

			</ModalForAll>

		</div>
	);
};

export default HomePerfilEdit;
